module.exports = __webpack_public_path__ + "static/img/AI-4.809f472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI-4.jpg
// module id = /2oO
// module chunks = 36